import { useState } from 'react';
import { InstallHelpSheet } from '../../components/InstallHelpSheet';
import { useInstallPrompt } from '../../lib/installPrompt';

/**
 * Install Autopostmate as an app on this device. Shown only where installing is
 * possible and the app is not already installed: a browser that offered an
 * install prompt gets a button for it, an iPhone or iPad gets the steps.
 */
export function InstallCard() {
  const install = useInstallPrompt();
  const [isHelpOpen, setIsHelpOpen] = useState(false);

  if (!install.isOffered) return null;

  return (
    <section className="wizard settings-card">
      <div className="settings-card__head">
        <h2 className="wizard__title">Install the app</h2>
        <p className="settings-card__lede">
          Open Autopostmate from your home screen or dock, in its own window. It still opens with no
          connection, and asks before it updates.
        </p>
      </div>
      <div>
        {install.canPrompt ? (
          <button className="button" type="button" onClick={() => void install.prompt()}>
            Install Autopostmate
          </button>
        ) : (
          <button className="button" type="button" onClick={() => setIsHelpOpen(true)}>
            Show me how
          </button>
        )}
      </div>
      {isHelpOpen ? <InstallHelpSheet onDismiss={() => setIsHelpOpen(false)} /> : null}
    </section>
  );
}
